import { isClient } from "@/utils";
import { CAROUSEL_CARD, CAROUSEL_WRAPPER } from "../Constants/elements";
import { useEffect, useState } from "react";

export const useCarousel = (carouselRef) => {
    const [isHaveButton, setIsHaveButton] = useState(false);

    const handleNextSlide = () => {
        if (!carouselRef.current || !isClient) return;

        // Get width of the carousel card
        const { scrollLeft, clientWidth, scrollWidth } = carouselRef.current;
        const items = carouselRef.current.querySelectorAll(`#${CAROUSEL_CARD}`);
        const itemWidth = items[0].getBoundingClientRect().width;

        // Get the gap between the items
        const gapElement = carouselRef.current.querySelector(`#${CAROUSEL_WRAPPER}`);
        const gapStyle = getComputedStyle(gapElement);
        const gap = gapStyle.getPropertyValue('gap');
        const gapNumber = parseFloat(gap);

        let tmpWidth = 0;
        let indexItem = 0;

        for (let i = 0; i < items.length; i++) {
            tmpWidth += itemWidth + gapNumber;
            if (tmpWidth > scrollLeft + clientWidth) {
                indexItem = i;
                break;
            }
        }

        const newScrollLeft = indexItem * (itemWidth + gapNumber);
        const maxScrollLeft = scrollWidth - clientWidth;
        carouselRef.current.scrollTo({ left: Math.min(newScrollLeft, maxScrollLeft), behavior: 'smooth' });
    };

    const checkIsHaveButton = () => {
        if (!carouselRef.current || !isClient) return false;

        const maxWrapperCarousel = carouselRef.current.parentElement.getBoundingClientRect().width;
        const itemWidth = carouselRef.current.querySelector(`#${CAROUSEL_CARD}`).getBoundingClientRect().width;
        const items = carouselRef.current.querySelector(`#${CAROUSEL_WRAPPER}`).children.length;
        const gapElement = carouselRef.current.querySelector(`#${CAROUSEL_WRAPPER}`);
        const gapStyle = getComputedStyle(gapElement);
        const gap = gapStyle.getPropertyValue('gap');
        const gapNumber = parseFloat(gap);

        return items * itemWidth + (items - 1) * gapNumber > maxWrapperCarousel;
    };

    useEffect(() => {
        setIsHaveButton(checkIsHaveButton());

        const handleResize = () => {
            setIsHaveButton(checkIsHaveButton());
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { handleNextSlide, isHaveButton };
};
